export default __webpack_public_path__ + "static/silka-light-webfont-ab62ce1057468f7468731162c3824c6d.woff";